import { CIcon } from '~/icons/types'

export const ciStarHalf: CIcon = {
  width: '24',
  height: '23',
  paths: [
    {
      d:
        'm22.77 7.68-6.553-.955L13.288.798A1.426 1.426 0 0 0 11.998 0c-.51 0-1.02.264-1.285.798l-2.93 5.927-6.554.953c-1.175.17-1.646 1.616-.794 2.445l4.741 4.612-1.122 6.513c-.16.93.584 1.677 1.416 1.677.22 0 .447-.052.665-.168L12 19.682l5.863 3.076c.217.114.444.166.664.166.832 0 1.577-.743 1.417-1.674l-1.12-6.515 4.742-4.61c.852-.829.381-2.275-.794-2.445Zm-5.45 5.516-.811.789.191 1.114.874 5.08-4.573-2.4L12 17.254l.002-14.203 2.284 4.625.501 1.013 1.12.163 5.115.745-3.701 3.599Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'star-half',
  type: 'regular'
}
